import {RangeRadioGroupComponent} from './range-radio-group.component';

export * from './range-radio-group.component'

export const RANGE_RADIO_GROUP_COMPONENTS = [
    RangeRadioGroupComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/range-radio-group/index.ts